'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AssetBusinessTypeUrls from '../constants/urls/AssetBusinessType';
import AssetPageTypeUrls from '../constants/urls/AssetPageType';
import AssetPageFeatureUrls from '../constants/urls/AssetPageFeature';
import StorefrontContainer from '../containers/StorefrontContainer';
import StorefrontHomeContainer from '../containers/StorefrontHomeContainer';
import ThemesStorefrontContainer from '../containers/ThemesStorefrontContainer';
import ThemeDetailsContainer from '../containers/ThemeDetailsContainer';
import ThemeDetailsPreviewContainer from '../containers/ThemeDetailsPreviewContainer';
import ThemesAllBusinessTypesContainer from '../containers/ThemesAllBusinessTypesContainer';
import { selectCollections, selectCollectionSlugs } from '../slices/collections/collectionsSlice';

const makeObjectValuesRouteParam = (obj, name) => {
  const routeValues = Object.values(obj).join('|');
  return `:${name}(${routeValues})`;
};

const businessTypeRouteParam = makeObjectValuesRouteParam(AssetBusinessTypeUrls, 'businessType');
const pageTypeRouteParam = makeObjectValuesRouteParam(AssetPageTypeUrls, 'pageType');
const pageFeatureRouteParam = makeObjectValuesRouteParam(AssetPageFeatureUrls, 'pageFeature');
const pageRouteParam = ':pageNumber([1-9][0-9]*)';
export default function Routes() {
  const collections = useSelector(selectCollections);
  const collectionSlugs = useSelector(selectCollectionSlugs);
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/themes/_preview/:slug",
      exact: true,
      sensitive: true,
      children: /*#__PURE__*/_jsx(ThemeDetailsPreviewContainer, {})
    }), /*#__PURE__*/_jsx(Route, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: ['/', ...collectionSlugs, '/categories', '/all', `/all/page/${pageRouteParam}`, `/${businessTypeRouteParam}`, `/${businessTypeRouteParam}/page/${pageRouteParam}`, `/${pageTypeRouteParam}`, `/${pageTypeRouteParam}/page/${pageRouteParam}`, `/${pageFeatureRouteParam}`, `/${pageFeatureRouteParam}/page/${pageRouteParam}`, `/${businessTypeRouteParam}/${pageTypeRouteParam}`, `/${businessTypeRouteParam}/${pageTypeRouteParam}/page/${pageRouteParam}`, `/${businessTypeRouteParam}/${pageFeatureRouteParam}`, `/${businessTypeRouteParam}/${pageFeatureRouteParam}/page/${pageRouteParam}`, `/${pageTypeRouteParam}/${pageFeatureRouteParam}`, `/${pageTypeRouteParam}/${pageFeatureRouteParam}/page/${pageRouteParam}`],
          exact: true,
          sensitive: true,
          children: /*#__PURE__*/_jsx(StorefrontContainer, {
            children: /*#__PURE__*/_jsxs(Switch, {
              children: [/*#__PURE__*/_jsx(Route, {
                path: "/",
                exact: true,
                children: /*#__PURE__*/_jsx(StorefrontHomeContainer, {})
              }), collections.map(collection => /*#__PURE__*/_jsx(Route, {
                path: `/${collection.slug}`,
                exact: true,
                children: /*#__PURE__*/_jsx(ThemesStorefrontContainer, {
                  collectionCategory: collection.id,
                  collectionQuery: collection.query,
                  description: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `marketplace-assets-ui.collections.collection_${collection.id}.subtitle`
                  }),
                  title: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `marketplace-assets-ui.collections.collection_${collection.id}.title`
                  })
                })
              }, collection.id)), /*#__PURE__*/_jsx(Route, {
                path: "/categories",
                exact: true,
                children: /*#__PURE__*/_jsx(ThemesAllBusinessTypesContainer, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: ['/all', `/all/page/${pageRouteParam}`, `/${businessTypeRouteParam}`, `/${businessTypeRouteParam}/page/${pageRouteParam}`, `/${pageTypeRouteParam}`, `/${pageTypeRouteParam}/page/${pageRouteParam}`, `/${pageFeatureRouteParam}`, `/${pageFeatureRouteParam}/page/${pageRouteParam}`, `/${businessTypeRouteParam}/${pageTypeRouteParam}`, `/${businessTypeRouteParam}/${pageTypeRouteParam}/page/${pageRouteParam}`, `/${businessTypeRouteParam}/${pageFeatureRouteParam}`, `/${businessTypeRouteParam}/${pageFeatureRouteParam}/page/${pageRouteParam}`, `/${pageTypeRouteParam}/${pageFeatureRouteParam}`, `/${pageTypeRouteParam}/${pageFeatureRouteParam}/page/${pageRouteParam}`],
                exact: true,
                children: /*#__PURE__*/_jsx(ThemesStorefrontContainer, {})
              }), /*#__PURE__*/_jsx(Redirect, {
                to: "/"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: ['/themes', `/themes/page/${pageRouteParam}`],
          render: routeProps => {
            const {
              match: {
                params: {
                  pageNumber
                }
              },
              location: {
                search
              }
            } = routeProps;
            return /*#__PURE__*/_jsx(Switch, {
              children: /*#__PURE__*/_jsx(Redirect, {
                to: {
                  pathname: `/all${pageNumber ? `/page/${pageNumber}` : ''}`,
                  search
                }
              })
            });
          },
          exact: true,
          sensitive: true
        }), /*#__PURE__*/_jsx(Redirect, {
          from: "/themes/all-business-types",
          to: "/categories",
          exact: true,
          sensitive: true
        }), /*#__PURE__*/_jsx(Redirect, {
          from: "/themes/:slug",
          to: "/:slug",
          exact: true,
          sensitive: true
        }), /*#__PURE__*/_jsx(Redirect, {
          from: "/themes/:slug/write-review",
          to: "/:slug/write-review",
          exact: true,
          sensitive: true
        }), /*#__PURE__*/_jsx(Route, {
          path: ['/:slug', '/:slug/write-review'],
          exact: true,
          sensitive: true,
          children: /*#__PURE__*/_jsx(ThemeDetailsContainer, {})
        }), /*#__PURE__*/_jsx(Redirect, {
          to: "/"
        })]
      })
    }), /*#__PURE__*/_jsx(Redirect, {
      to: "/"
    })]
  });
}